import { FilterInput, InputMessage } from '@wrisk/ui-components'
import React, { FunctionComponent, useEffect } from 'react'

import { useApiErrorHandlingAsync } from '../../../../../hooks/auth'
import { usePrincipal } from '../../../../authentication'

export interface VehicleMakesFilterProps {
  onSelect: (make: string | undefined) => void
  profile?: string
  year: number
  make?: string
}

export const VehicleMakesFilter: FunctionComponent<VehicleMakesFilterProps> = ({
  onSelect,
  profile,
  year,
  make,
}) => {
  const { apiClient } = usePrincipal()

  const { result, loading } = useApiErrorHandlingAsync(
    async () => await apiClient.lookupVehicleMakes({ year }, profile),
    [],
  )

  useEffect(() => {
    if (result?.length === 1 && !make) {
      onSelect(result.at(0))
    }
  }, [result, make])

  const hasSingleResult = result?.length === 1
  const noOptions = result?.length === 0

  return hasSingleResult || loading || !result ? null : noOptions ? (
    <InputMessage
      width={1}
    >{`We couldn’t find any models manufactured in ${year}.`}</InputMessage>
  ) : (
    <FilterInput
      data-testid='vehicle-make'
      placeholder='Make'
      value={make}
      width={1}
      onSelect={onSelect}
      options={result}
      renderOption={renderOption}
      renderOptionText={renderOption}
      matchOption={matchOption}
    />
  )
}

const renderOption = (make: string) => make
const matchOption = (text: string) => (option: string) =>
  option.toLowerCase().includes(text.toLowerCase())
